import React from "react";
import Modal from "react-bootstrap/Modal";

const DeleteModalComponent = (props) => {
  console.log("props.rowDataUser.", props.rowDataUser);
  return (
    <Modal
      size="m"
      show={props.isShow}
      onHide={props.handleClose}
      backdrop="static"
      centered
      keyboard={false}
    >
      <Modal.Header style={{ backgroundColor: "rgb(0, 42, 74)" }}>
        <Modal.Title style={{ fontFamily: "Roboto", color: "white" }}>
          {props.title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="container ">{"Are you sure want to delete?"}</div>
      </Modal.Body>

      <Modal.Footer>
        <div
          className="row col-12 col-sm-12 col-md-12 col-lg-12"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div className="col-12 col-sm-12 col-md-12 col-lg-6">
            <button
              style={{
                backgroundColor: "#002a4a",
                height: "100%",
                color: "white",
                width: "100%",
                borderRadius: 8,
                borderWidth: 1,
              }}
              onClick={() => {
                let obj = {};
                if (props.driverManagement) {
                  obj = {
                    id: props.data.user_id,
                    email: props.data.email,
                    firstName: props.data.firstName,
                    lastName: props.data.lastName,
                    password: props.data.password,
                    permissions: [props.data?.userRoles[0]?.user_role_id],
                    division_id: props.data?.division_id,
                    is_active: false,
                  };
                } else if (props.truckManagement) {
                  obj = {
                    bt_id: props.data.bt_id,
                    type: props.data.type,
                    division_id: props.data.division_id,
                    is_active: false,
                    truck_id: props.data.truck_id,
                  };
                } else if (props.UserManagement) {
                  obj = {
                    id: props.rowDataUser.user_id,
                    email: props.rowDataUser.email,
                    firstName: props.rowDataUser.firstName,
                    lastName: props.rowDataUser.lastName,
                    password: "",
                    permissions: props.rowDataUser.permissions,
                    division_id: props.rowDataUser.division_id,
                    is_active: false,
                  };
                } else if (props.LotsManagement) {
                  obj = {
                    lotName: props.data.lotName,
                    division_id: parseInt(props.data.division_id),
                    lot_id: props.data.lot_id,
                    is_active: false,
                  };
                }
                props.setValue(obj);
              }}
            >
              {"Ok"}
            </button>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-6">
            <button
              onClick={() => {
                props.show(false);
              }}
              style={{
                backgroundColor: "#002a4a",
                height: "100%",
                color: "white",
                width: "100%",
                borderRadius: 8,
                borderWidth: 1,
              }}
            >
              {"Cancel"}
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default DeleteModalComponent;
